module.exports = __webpack_public_path__ + "static/media/independent-usborne-organiser.c159ac7c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/exhibitors/independent-usborne-organiser.jpeg
// module id = 455
// module chunks = 0